import TasksEntitlementRoute from './tasks-entitlement.route';
import { Route } from 'react-router-dom';
import { lazyRoute } from './lazy-route';
import { organizationFarmRoutes } from './organization-farm.routes';

const Tasks = lazyRoute(() => import('pages/tasks/tasks.container'));
const TasksOrg = lazyRoute(() => import('pages/tasks/tasks-org.container'));
const TasksNewPrescription = lazyRoute(() => import('pages/tasks/task-create/task-prescription.container'));
const SprayRegistration = lazyRoute(() => import('pages/tasks/task-create/spray-registration/spray-registration.container'));
const TaskCreate = lazyRoute(() => import('pages/ag-operations/ag-operations-create-mfe/ag-operations-create.container'));

/* A contract with hide_tasks is sent away from every tasks url, not only from the list. */
export const tasksRoutes = (
  <Route element={<TasksEntitlementRoute />}>
    <Route path={organizationFarmRoutes.tasks.organization} element={<TasksOrg />} />
    <Route path={organizationFarmRoutes.tasks.property} element={<Tasks />} />
    <Route path='/company/:companyId/property/:propertyId/tasks/new-prescription' element={<TasksNewPrescription />} />
    <Route path='/company/:companyId/property/:propertyId/tasks/spray-registration' element={<SprayRegistration />} />
    <Route path='/company/:companyId/property/:propertyId/tasks/ag-operations/:taskType' element={<TaskCreate />} />
  </Route>
);
